/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_appsync_graphqlEndpoint": "https://iwuvabzy7ba2nar6est4k7637i.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-2x4hvi26gjhctk5ar7vvslgbqe",
    "aws_cognito_identity_pool_id": "us-east-1:cc437e43-a65f-4796-8cee-59904389dc82",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_d6AJ8PE4w",
    "aws_user_pools_web_client_id": "7ffr9taokae1e0ln29t077ubak",
    "oauth": {}
};


export default awsmobile;
